import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from 'axios';
import { getDjangoEndpoint } from "src/utils/apiEndpoints";


export interface iManualPDFState {
    url: string | null;
    loading: boolean;
    error: string | null;
}

const initialState: iManualPDFState = {
    url: null,
    loading: false,
    error: null,
};


export const manualAPI = createAsyncThunk(
    "GET_MANUAL_PDF",
    async (
      manual: { language: string },
      { rejectWithValue }
    ) => {
      try {
  
        const djangoEndpoint = getDjangoEndpoint();
        const pathParam = '/tools/manual/'
          
        const response = await axios.post(
          `${djangoEndpoint}${pathParam}`, 
          {
            language: manual.language
          },
          {
            withCredentials: true,
          }
        );
        return response.data;
      } catch (error) {
        console.error('로그인 API 호출 에러:', error);
        return rejectWithValue(error.response ? error.response.data : error.message);
      }
    }
  );

  export const manualPDFSlice = createSlice({
    name: "manualPDF",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(manualAPI.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(manualAPI.fulfilled, (state, action) => {
                state.loading = false;
                state.url = action.payload.url; // Assuming the API returns { url: "..." }
            })
            .addCase(manualAPI.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string || 'Failed to fetch manual PDF';
            });
    },
});

export default manualPDFSlice.reducer;